import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SocialPublishId = Brand<number, 'SocialPublishId'>;
export const SocialPublishId = createBranded<SocialPublishId>();
